var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.24656 5.05039L3.29322 5.10781L6.8186 9.38711C6.93784 9.53203 7.1167 9.62226 7.3163 9.62226C7.51589 9.62226 7.69476 9.5293 7.814 9.38711L11.3368 5.11602L11.3964 5.04492C11.4405 4.97656 11.4664 4.89453 11.4664 4.80703C11.4664 4.56914 11.2746 4.375 11.0361 4.375H3.60169C3.36321 4.375 3.17139 4.56914 3.17139 4.80703C3.17139 4.89727 3.1999 4.98203 3.24656 5.05039Z",
    fill: "#4B4D22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.28776b88f5b9cf90474b00994c599f82.svg";
export { ForwardRef as ReactComponent };